import React from 'react'
import { useState, useEffect } from 'react';
import { make_readable_date } from '../../js functions/chartCompute.js';
import { get_data_of_exercise } from '../../js functions/LDBfunctions';
import Counter from './master/counter.js';
import Line_chart from './master/Line_chart.js';


function Volume({ dateRangeStart, dateRangeEnd, ActiveExcercise }) {

  const [volumeData, setVolumeData] = useState([]);
  const [slope, setSlope] = useState(0);

  const heading = "New Total Volume";
  const Yaxis_name = "Total Volume";


  useEffect(() => {

    compute_volume(dateRangeStart, dateRangeEnd, ActiveExcercise);

  }, [dateRangeStart, dateRangeEnd, ActiveExcercise]);




  async function compute_volume(dateRangeStart, dateRangeEnd, ActiveExcercise) {
    try {
      let data = await get_data_of_exercise(dateRangeStart, dateRangeEnd, ActiveExcercise); //array between from and to dates of specific excercise

      // Check if data is undefined or empty
      if (!data || data.length === 0) {
        console.log('No data available for the selected exercise and date range');
        setVolumeData([]);
        setSlope(0);
      
      } else {

        const chartData = [];
        const regressionLine = [];

        //vars for linear regression
        const n = data.length;
        let sumX = 0;
        let sumY = 0;
        let sumXY = 0;
        let sumXX = 0;

        data.map((record, index) => { //each record is one date.
          const start_time = new Date(record.start_time);
          const sets = record.sets;
          const volume_array = []; // multiples rep x weight_kg and stores as arrow

          sets.map((set) => {
            volume_array.push(set.weight_kg * set.reps);
          });

          const total_volume = volume_array.reduce((acc, curr) => acc + curr, 0);

          // For linear regression calculation
          sumX += index;
          sumY += total_volume;
          sumXY += index * total_volume;
          sumXX += index * index;

          chartData.push({
            y: total_volume,
            x: make_readable_date(start_time)
          });
        });

        // Calculate regression line
        const slope = (n * sumXY - sumX * sumY) / (n * sumXX - sumX * sumX);
        const intercept = (sumY - slope * sumX) / n;

        // Add regression values to chartData
        chartData.forEach((point, index) => {
          point.z = slope * index + intercept;
        });

        setSlope(slope);
        setVolumeData(chartData);



      }
    } catch (error) {
      console.error('Error fetching data:', error);
    }



    }




  return (


      <div className='chart-card-container'>
        <h4>{heading}</h4>

        <div className="chart-card">


          <div className='summary-box' >



            <div className='counter-box' >

              <Counter counterData={slope} heading={"Slope"} />

              <Counter />

            </div>


            <p> Great job! Your total volume for incline dumbbell press has increased by 15% over the last month. This shows your chest and upper body strength are improving steadily. Keep it up!  </p>
          </div>



          <Line_chart data={volumeData} Yaxis_name={Yaxis_name}  />

       

        </div>


      </div>


    )
  }

  export default Volume